import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { SnackbarProvider } from 'notistack';
import { RootStoreSingleton } from './stores/rootStore';
import 'semantic-ui-css/semantic.min.css';
import './index.css';

ReactDOM.render(
  <Provider RootStore={RootStoreSingleton}>
    {/* 
        NOTE: Strict mode causes components wrapped in mobx observer() to render twice.
        This should not be a problem, since this mode is only for development, but keep in mind
        ref: https://stackoverflow.com/questions/55435090/why-are-react-components-rendering-twice-when-wrapped-with-observer
    */}
    <React.StrictMode>
      <SnackbarProvider maxSnack={5}>
        <App />
      </SnackbarProvider>      
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);